import {guard, IS_ELEMENT} from '@acng/frontend-rubicon';
import {CLICK, on} from '@acng/frontend-bounty/dom/event.js';
import {isMobile} from './service/env.js';
import {goBack} from './service/location.js';

export const navigator = {
  desktop: !isMobile,
  mobile: isMobile,
  /**
   * @param {Node} node
   */
  back: (node) => {
    ASSERT: guard(node, IS_ELEMENT);
    on(node, CLICK, () => goBack());
  },
};
